import type { FC } from 'react';
import React from 'react';

import { VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE } from '@confluence/experience-tracker/entry-points/ExperienceName';
import { ExperienceStart } from '@confluence/experience-tracker/entry-points/component';
import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary';
import { useSessionData } from '@confluence/session-data/entry-points/useSessionData';

import { FavouriteButtonComponent } from './FavouriteButtonComponent';
import { FAVOURITE_BUTTON_METRIC } from './perf.config';

type FavouriteButtonProps = {
	contentId: string;
	isDisabled?: boolean;
};

export const FavouriteButton: FC<FavouriteButtonProps> = ({ contentId, isDisabled }) => {
	const { isLoggedIn } = useSessionData();

	if (!isLoggedIn) {
		return null;
	}

	return (
		<ErrorBoundary attribution={Attribution.DISCO}>
			<PageSegmentLoadStart key={contentId} metric={FAVOURITE_BUTTON_METRIC} />
			<ExperienceStart id={contentId} name={VIEW_PAGE_FAVORITE_BUTTON_EXPERIENCE} />
			<FavouriteButtonComponent contentId={contentId} isDisabled={isDisabled} />
		</ErrorBoundary>
	);
};
